import { useNavigate } from "react-router-dom";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import { CustomButton } from "../../components/CustomButton";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import TableActionsContainer from "../../components/CustomTable/TableActionsContainer";
import { Text } from "../../components/Text";
import marketimg from "../../assets/MarketPlace.png";
import zohoimg from "../../assets/zoho.png";
import "./index.css";
import DebounceSearch from "../../components/common/DebounceSearch";
import IntegrationTile from "./IntegrationTile";
import { getZohoConfig } from "../../reducers/marketPlaceSlice";
import modulesName from "../../roles/modulesName";
import permissions from "../../roles/permissions";

function MarketPlace() {
  const { accesskey, user } = useSelector((state) => state.authenticate);
  const { zohoConfig } = useSelector((state) => state.marketPlace);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tiles = [
    {
      appName: "Zoho",
      appLogo: () => (
        <img
          src={zohoimg}
          alt={`zoho logo`}
          className="integration-tile-logo"
        />
      ),
      description:
        "Connect your favorite tools and apps to SkaleBot and unlock new features to streamline your business operations.",
      isSynced: zohoConfig?.refreshToken ? true : false,
      learnMore: () => {
        navigate("/marketplace/zoho");
      },
      view: accesskey[modulesName.ACCOUNT]?.includes(permissions.READ) || user?.role === "admin" ||user?.role === "superadmin",
    },
  ];

  useEffect(() => {
    dispatch(getZohoConfig());
  }, []);
  return (
    <div className="w-full mb-2 bg-white cp-10 ">
      <CustomBreadcrumb home={{ label: "Market Place", url: "/marketplace" }} />
      <div className="flex flex-column">
        <div className="flex flex-column space-y-4">
          <div className="marketplace-container">
            <div className="integration-section">
              <div className="integration-illustration">
                <img src={marketimg} />
              </div>
              <div className="integration-content">
                <h2>Expand SkaleBot power with seamless integrations!</h2>
                <p>
                  Connect your favorite tools and apps to SkaleBot and unlock
                  new features to streamline your business operations.
                </p>
              </div>
            </div>
          </div>
          <div>
            <TableActionsContainer>
              <div className="flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="flex gap-3 justify-content-between align-items-center flex-grow-1">
                  <Text type={"heading"}>App List</Text>
                </div>
                <div className="flex gap-3 flex-wrap-reverse">
                  {/* <div className="flex gap-2 flex-wrap ">
                          <DebounceSearch
                            placeholder={"Search App"}
                            inputValue={""}
                            handleInputChange={()=>{}}
                          />
                        </div> */}
                </div>
              </div>
            </TableActionsContainer>
          </div>
          <div>
            <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
              {tiles
                ?.filter((x) => x.view)
                ?.map((tile, index) => (
                  <IntegrationTile
                    key={index}
                    appName={tile.appName}
                    appLogo={tile.appLogo}
                    description={tile.description}
                    isSynced={tile.isSynced}
                    onSyncToggle={() => {tile?.learnMore();}}
                    onLearnMore={() => {
                      tile?.learnMore();
                    }}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MarketPlace;
